'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _reactUtils = require('react-utils');

var _ComponentWithBodyClass = require('../utils/ComponentWithBodyClass');

var _ComponentWithBodyClass2 = _interopRequireDefault(_ComponentWithBodyClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Standard page container, setting classes, context, etc.
 */
exports.default = _react2.default.createClass({
  displayName: 'UIPage',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: _extends({}, _ComponentWithBodyClass2.default.propTypes, {
    bodyClassName: _react.PropTypes.string,
    children: _react.PropTypes.node.isRequired,
    className: _react.PropTypes.string,
    tagName: _react.PropTypes.string.isRequired
  }),

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _ComponentWithBodyClass2.default.defaultProps, {
      tagName: 'div'
    });
  },
  render: function render() {
    var _props = this.props,
        bodyClassName = _props.bodyClassName,
        bodyElement = _props.bodyElement,
        children = _props.children,
        className = _props.className,
        TagName = _props.tagName,
        rest = _objectWithoutProperties(_props, ['bodyClassName', 'bodyElement', 'children', 'className', 'tagName']);

    var classes = (0, _reactUtils.classNames)(className, 'private-page');
    var bodyClasses = (0, _reactUtils.classNames)(bodyClassName);

    var renderedChildren = _react2.default.createElement(
      TagName,
      _extends({}, rest, { className: classes }),
      children
    );

    if (bodyClassName) {
      return _react2.default.createElement(
        _ComponentWithBodyClass2.default,
        {
          bodyClassName: bodyClasses,
          bodyElement: bodyElement
        },
        renderedChildren
      );
    }

    return renderedChildren;
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/page/UIPage.js
// module id = 373
// module chunks = 0